module.exports = __webpack_public_path__ + "img/API-min.71e31677.webp";